import { resetPrefetchMismatchMetrics } from "../../internal/prefetching/usePrefetchCounter";
export default resetPrefetchMismatchMetrics;

//# sourceMappingURL=resetPrefetchMismatchMetrics.js.map